import { Group, Bone } from "three";

export class RiggedMesh {
    public group: Group;

    public bones: Bone[];

    constructor(group: Group, bones: Bone[] = []) {
        this.group = group;
        this.bones = bones;
    }
}

export const Inventory = {
    SM_surgeonRigged: null as RiggedMesh | null,
};
